import { categories } from '@/mocks/content';

const categoryImages: Record<string, string> = {
  Shoes: 'https://readdy.ai/api/search-image?query=High%20end%20fashion%20sneakers%20in%20warm%20earth%20tones%20displayed%20on%20rustic%20wooden%20surface%20with%20soft%20natural%20side%20lighting%20minimalist%20product%20photography%20elegant%20textures%20rich%20leather%20details%20clean%20background%20no%20text%20no%20logos&width=400&height=400&seq=vigor-v2-cat-shoes&orientation=squarish',
  'Hoodies/Sweaters': 'https://readdy.ai/api/search-image?query=Premium%20soft%20cashmere%20hoodie%20in%20warm%20sand%20color%20casually%20draped%20over%20wooden%20chair%20with%20gentle%20morning%20light%20streaming%20in%20cozy%20aesthetic%20editorial%20fashion%20photography%20clean%20composition%20no%20text%20no%20logos&width=400&height=400&seq=vigor-v2-cat-hoodies&orientation=squarish',
  'T-Shirts': 'https://readdy.ai/api/search-image?query=High%20quality%20organic%20cotton%20tshirt%20in%20warm%20ivory%20tone%20neatly%20folded%20on%20light%20marble%20surface%20with%20subtle%20shadow%20play%20soft%20diffused%20studio%20lighting%20minimalist%20product%20style%20no%20text%20no%20logos&width=400&height=400&seq=vigor-v2-cat-tshirts&orientation=squarish',
  Jackets: 'https://readdy.ai/api/search-image?query=Modern%20stylish%20lightweight%20jacket%20in%20olive%20green%20tone%20hanging%20on%20warm%20wooden%20wall%20hook%20natural%20window%20light%20casting%20soft%20shadows%20editorial%20fashion%20photography%20clean%20aesthetic%20no%20text%20no%20logos&width=400&height=400&seq=vigor-v2-cat-jackets&orientation=squarish',
  'Pants/Shorts': 'https://readdy.ai/api/search-image?query=Trendy%20tailored%20beige%20pants%20elegantly%20folded%20on%20warm%20terracotta%20tiled%20surface%20with%20soft%20overhead%20lighting%20minimalist%20apparel%20photography%20clean%20lines%20sophisticated%20casual%20style%20no%20text%20no%20logos&width=400&height=400&seq=vigor-v2-cat-pants&orientation=squarish',
  Headwear: 'https://readdy.ai/api/search-image?query=Stylish%20structured%20baseball%20cap%20in%20warm%20sand%20color%20resting%20on%20smooth%20stone%20surface%20with%20dappled%20natural%20sunlight%20clean%20minimal%20product%20photography%20contemporary%20streetwear%20aesthetic%20no%20text%20no%20logos&width=400&height=400&seq=vigor-v2-cat-headwear&orientation=squarish',
  Sets: 'https://readdy.ai/api/search-image?query=Coordinated%20fashion%20outfit%20matching%20set%20in%20soft%20earth%20tones%20laid%20out%20elegantly%20on%20warm%20linen%20fabric%20surface%20soft%20morning%20light%20editorial%20fashion%20styling%20clean%20composition%20no%20text%20no%20logos&width=400&height=400&seq=vigor-v2-cat-sets&orientation=squarish',
  'Underwear/Underpants': 'https://readdy.ai/api/search-image?query=Premium%20soft%20cotton%20underwear%20basics%20in%20warm%20neutral%20tones%20neatly%20arranged%20on%20light%20wood%20surface%20with%20gentle%20natural%20lighting%20clean%20minimalist%20product%20photography%20subtle%20texture%20details%20no%20text%20no%20logos&width=400&height=400&seq=vigor-v2-cat-underwear&orientation=squarish',
};

const displayCategories = categories.slice(0, 8);

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-500">Categories</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-4">
            Popular Categories
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            Browse through our curated Vigorbuy categories. Each category links directly to the official store with verified products.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {displayCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-white rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-square overflow-hidden bg-background-100">
                {categoryImages[cat.name] && (
                  <img
                    src={categoryImages[cat.name]}
                    alt={`${cat.name} category on Vigorbuy`}
                    title={`Browse ${cat.name} - Vigorbuy Spreadsheet`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                )}
                {cat.hot && (
                  <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider">
                    Hot
                  </span>
                )}
              </div>
              <div className="p-4 text-center">
                <span className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <div className="flex items-center justify-center gap-1 mt-1.5">
                  <span className="text-xs text-foreground-400">Shop Now</span>
                  <i className="ri-arrow-right-up-line text-xs text-foreground-400"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {categories.slice(8).map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-white border border-background-200/60 rounded-full text-sm text-foreground-600 hover:text-primary-500 hover:border-primary-300 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}